import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60bfccaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = { class: "icon" }
const _hoisted_3 = { class: "card-footer" }

import { withDefaults } from 'vue';

interface IProps {
  title: string;
  count: number;
  classes: string;
  maxWidth?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeCountCard',
  props: {
    title: { default: '' },
    count: { default: 0 },
    classes: { default: '' },
    maxWidth: { default: '175px' }
  },
  emits: ['handleClick'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

function handleClick() {
  emit('handleClick');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: handleClick,
    class: _normalizeClass(["card-container", props.classes])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "icon")
      ]),
      _createElementVNode("span", {
        class: "pl-2",
        style: _normalizeStyle({ 'max-width': _ctx.maxWidth })
      }, _toDisplayString(props.title), 5)
    ]),
    _createElementVNode("span", _hoisted_3, _toDisplayString(props.count), 1)
  ], 2))
}
}

})